module.exports = __webpack_public_path__ + "img/DK36200359.f774812e.png";